import { IconFunctionalWarningCircle16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import { INFO_MESSAGE_TEXT_MAP } from './constants';
import { InfoMessage } from '../../components/InfoMessage';
import { IMessageAssumptionsSchema } from '../../types/messages';
import { useApplicationContext } from '../../utils/applicationContext';
import { isMessageAssumptionsEnabled } from '../../utils/isMessageAssumptionsEnabled';

type TInfoMessageProps = {
  isOutcoming: boolean;
  assumptions?: IMessageAssumptionsSchema | null;
};

export const InfoMessageContainer: React.VFC<TInfoMessageProps> = ({ isOutcoming, assumptions }) => {
  const { config } = useApplicationContext();

  if (!assumptions?.isTransferToAnotherCommunicationChannel || !isMessageAssumptionsEnabled(config)) {
    return null;
  }

  const messageType = isOutcoming ? 'outcoming' : 'incoming';

  const text = INFO_MESSAGE_TEXT_MAP.isTransferToAnotherCommunicationChannel[messageType];

  return <InfoMessage text={text} icon={<IconFunctionalWarningCircle16 color="icon-warning-default" />} />;
};
